import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const RECOGNITION_FACE_AVATAR_CLASS_NAME = 'RecognitionFaceAvatar';
export const RECOGNITION_FACE_AVATAR_CLASS_SLOTS: Array<
	keyof RecognitionFaceAvatarClasses
> = ['root'] as const;

export type RecognitionFaceAvatarClassSlot =
	(typeof RECOGNITION_FACE_AVATAR_CLASS_SLOTS)[number];

export interface RecognitionFaceAvatarClasses {
	root: string;
}

export type RecognitionFaceAvatarClassKey = keyof RecognitionFaceAvatarClasses;

export const getRecognitionFaceAvatarUtilityClass = (slot: string) =>
	generateUtilityClass(
		RECOGNITION_FACE_AVATAR_CLASS_NAME,
		slot as RecognitionFaceAvatarClassSlot,
	);

export const recognitionFaceAvatarClasses: RecognitionFaceAvatarClasses =
	generateUtilityClasses(
		RECOGNITION_FACE_AVATAR_CLASS_NAME,
		RECOGNITION_FACE_AVATAR_CLASS_SLOTS.concat([]),
	);

export default recognitionFaceAvatarClasses;
